import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector, getStore } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/StoreActions';
import DeleteGroupPopup from './DeleteStorePopup';

const mapDispatchToProps = (dispatch) => ({
	deleteStore: (storeId) =>
		dispatch(
			actionLayer.deleteStore.request({
				...storeId,
			})
		),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => getStore(state, 'isLoading'), false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, false),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(DeleteGroupPopup);
